import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkbox-checked-inactive--sprite",
  "use": "checkbox-checked-inactive--sprite-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checkbox-checked-inactive--sprite\">\n\t<g fill=\"none\">\n\t\t<g>\n\t\t\t<rect stroke=\"#787d80\" fill=\"#787d80\" x=\"0.5\" y=\"0.5\" width=\"19\" height=\"19\" rx=\"2\">\n\t\t\t</rect>\n\t\t\t<polyline stroke=\"#FFFFFF\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" points=\"5 9.813 9.709 14.063 15.822 7\">\n\t\t\t</polyline>\n\t\t</g>\n\t</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol